import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { DateTime } from 'luxon';

import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { Skeleton } from 'src/common/Skeleton';


import { isDispatchTrip } from '../../../common/isDispatchTrip';

interface TripDetailsEstimatedCompletionProps {
  isTripDataLoading: boolean;
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead;
}

export function TripDetailsEstimatedCompletion({
  isTripDataLoading,
  trip,
}: TripDetailsEstimatedCompletionProps) {
  if (!isDispatchTrip(trip)) {
    return null;
  }

  if (!trip.timing?.estimated_completion_time && !isTripDataLoading) {
    return null;
  }

  return (
    <div>
      <div className="flex items-center gap-2">
        <h4 className="py-2 text-sm font-bold">Estimated Completion</h4>
        <SimpleTooltip
          trigger={
            <InformationCircleIcon
              data-testid="estimated-completion-tooltip-trigger"
              className="h-4 w-4"
            />
          }
          content={
            <p data-testid="estimated-completion-tooltip-content">
              Estimated completion time of the trip including delays, travel
              time, load time, and unload time.
            </p>
          }
        />
      </div>
      {isTripDataLoading ? (
        <Skeleton />
      ) : (
        trip.timing?.estimated_completion_time && (
          <div className="text-sm">
            <p className="text-sm font-medium text-gray-500">
              {DateTime.fromISO(
                trip.timing.estimated_completion_time
              ).toLocaleString(DateTime.DATETIME_MED)}
            </p>
          </div>
        )
      )}
    </div>
  );
}
